var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('button',{staticClass:"menu-item",class:{ 'is-active': _vm.isActive ? _vm.isActive(): null, 'hover': _vm.action ? true : null },attrs:{"title":_vm.title},on:{"click":() => _vm.action ? _vm.action(): null}},[_c('svg',{staticClass:"remix"},[_c('use',{attrs:{"href":`${_vm.remixiconUrl}#ri-${_vm.icon}`}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }